// 偶像資料
import { useSelector } from "react-redux";
import IdolCoverCard from '@/components/ui/IdolCoverCard';

const MyIdol = () => {
  // 主偶像資料
  const avatarUrl = useSelector((state) => state.user.avatarUrl);
  const nickName = useSelector((state) => state.user.nickName);
  const id = useSelector((state) => state.user.idolId);
  const idolUuid = useSelector((state) => state.user.idolUuid);
  const isOfficial = useSelector((state) => state.user.isOfficial);
  const coverUrl = useSelector((state) => state.user.coverUrl);

  return (
    <IdolCoverCard
      href={`/idol/${idolUuid || id}`}
      coverUrl={coverUrl}
      avatarUrl={avatarUrl}
      nickName={nickName}
      isOfficial={isOfficial}
      className="mb-4"
    />
  );
};

export default MyIdol;
